(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    function showPricesIfMexicanCurrency() {
    if (window.Shopify && Shopify.currency && Shopify.currency.active === 'MXN') {
      document.querySelectorAll('.price, .price-container, product-price, [ref="priceContainer"]').forEach(function(el) {
        el.style.setProperty('display', 'revert', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
      });
    }
  }
  document.addEventListener('DOMContentLoaded', showPricesIfMexicanCurrency);
  document.addEventListener('shopify:section:load', showPricesIfMexicanCurrency);

  console.log(currency)
  } catch(e) { console.error(e); }
})();

})();
